var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgOlmIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 100,
    height: 100,
    fill: "#0f1689",
    stroke: "null",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#c00",
    d: "M50 13.438A36.562 36.562 0 1 1 13.438 50 36.562 36.562 0 0 1 50 13.438"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M28.519 55.592L58.241 17.74c.662 1.308 0 2.047-.258 2.83L49.794 42.8c-.697 1.867-.396 2.306 1.566 2.306h19.132c.516 0 1.213-.258 1.523.31s-.353.998-.654 1.437L46.998 79.103c-.387.525-.774 1.308-1.48.92s-.258-1.179 0-1.832l5.618-20.526c.49-1.609 0-1.961-1.471-1.918H31.487l-2.968-.155z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgOlmIcon);
export default __webpack_public_path__ + "static/media/olm-icon.8f5d3ebad8854ee073e6de4f8b731a19.svg";
export { ForwardRef as ReactComponent };